"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgShowerLowOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.shower-low_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "shower-low_outline_svg__transparent_box" },
            React.createElement("path", { className: "shower-low_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "shower-low_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "shower-low_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M26.54 9.49A16.67 16.67 0 0019 7.36V5a3 3 0 00-3-3H8a3 3 0 00-3 3v25h2V5a1 1 0 011-1h8a1 1 0 011 1v2.36a16.67 16.67 0 00-7.54 2.13l-.46.3V14h18V9.79zM25 12H11v-1.08a15.78 15.78 0 017-1.59 15.94 15.94 0 017 1.59z" }),
            React.createElement("circle", { cx: 18, cy: 17, r: 1 }),
            React.createElement("circle", { cx: 18, cy: 21, r: 1 }),
            React.createElement("circle", { cx: 18, cy: 25, r: 1 }),
            React.createElement("circle", { cx: 18, cy: 29, r: 1 }))));
}
exports.default = SvgShowerLowOutline;
//# sourceMappingURL=ShowerLowOutline.js.map